export const DEFAULT_PAGE = 1;
export const DEFAULT_PER_PAGE = 20;
export const DEFAULT_PER_PAGE_MAX = 100;
export const DEFAULT_ADMIN_PER_PAGE_MAX = 500;
